<template>    
<section>


    <div class="portal">
      <div class="portal__block" :key="idx">
          
          <label v-if="block.name" class="full-width">{{block.name}}</label>
          <input v-else class="full-width" placeholder="Empty Block">

          <img @click="duplicateBlock(display)" class="icon" src="/static/admin/duplicate.svg" alt="">
          <img class="icon" src="/static/admin/text.svg" alt="">
          <img @click="mediaBlock = !mediaBlock" class="icon" src="/static/admin/camera.svg" alt="">
          <img class="icon" src="/static/admin/code.svg" alt="">

          <div class="edit" v-drag-and-drop:options="options">
            
              <vue-draggable-group
                v-model="group.items"
                :groups="group"
                :data-id="group.id"
                @change="onGroupsChange"
              >
            <ul class="portal__edit-child" >
              <li>hey</li>
            </ul>

              <ul class="portal__image-container">
                
                <li class="portal__image-parent" v-for="(display, idx) in media" :key="idx">
                  
                  <img :src="display.src">
                  
                </li>
                </ul>
              </vue-draggable-group>

          </div>
      </div>

      
    </div>
    </section>
    </template>

    <script>
import { page } from 'vue-analytics'
import { firestore } from '../main'
import firebase from 'firebase'

export default {
  
  data () {
    const componentInstance = this
    return {
      group: [{ id: 1, name: "added", items: [
            { id: 1, name: "Item 1", groupId: 1 },
            { id: 2, name: "Item 2", groupId: 1 },
            { id: 3, name: "Item 3", groupId: 1 }
          ] },{ id: 2, name: "staged",           items: [
            { id: 1, name: "Item 1", groupId: 1 },
            { id: 2, name: "Item 2", groupId: 1 },
            { id: 3, name: "Item 3", groupId: 1 }
          ]}],
      options: {
        dropzoneSelector: ".drag-inner-list",
        draggableSelector: ".drag-item"
      },
      tools: false,
      block: null,
      media: {},
      mediaBlock: false,
      editor: null,
      imageUrl: '',
      image: '',
      filename: '',
      urlPath: ''
    }
  },
  components: {
  },

  beforeDestroy() {
    this.editor.destroy()
  },
  firestore() {
    this.urlPath = this.$route.path.split('/admin/blocks/')[1]
    return {
      block: firestore.collection("blocks").doc(this.urlPath),
      media: firestore.collection("media")

    }
  },
  methods: {
    createBlock(){
      const createdAt = new Date()
      firestore.collection("blocks").add({createdAt: createdAt, options: false})
    },
    options(display){
      display.options = !display.options
    },
    saveBlock(display){
      firestore.collection('blocks').doc(display.id).update(display)
      .then((data) => {
        firestore.collection('blocks').doc(display.id).update({options: false})
      })
    },
    duplicateBlock(display){
      const createdAt = new Date()
      firestore.collection('blocks').add(display)
    },
    deleteBlock(display){
      firestore.collection('blocks').doc(display.id).delete()
    }
  }
}
</script>
<style lang="scss">
  .bigIcon {
    border: 1px solid #aaa;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    transition: all .25s ease-in-out;
  }
  .x {
    position: absolute;
    background-color: #93923f;
    color: #fff;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    top: -5px;
    left: 0;
    cursor: pointer;
  }
  .save {
    position: absolute;
    background-color: #93923f;
    color: #fff;
    padding: 2px 10px;
    width: auto;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 35px;
    bottom: -45px;
    right: 0;
    cursor: pointer;
  }
  .edit {
    // background-color: #ddd;
    width: 100%;
    margin: 1em 0 0 0;
    // height: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/BlockPage.vue